<template>
    <Head title="Forgot Password" />
    <GuestLayout :showExtras="false" headingTitle="Esqueci Minha Senha" :showBottomBarInDesktop="true">

    <div class="sm:px-5 xl:max-w-[350px] xl:min-w-[350px] mt-8">
        <h2 class="text-3xl font-semibold text-left xl:py-6 sm:py-4 pb:text-hover sm:text-primary">Código de Verificação</h2>
        <p class="text-lg pb:text-white">
            Nós enviamos o código de verificação para o email:
        </p>
        <span class="text-xl font-bold pb-4 inline-block pb:text-white">{{ recoveryEmail }}</span>

        <form @submit.prevent="submit" class="mb-4">
          <ul class="grid gap-5">
            <li>
              <label class="mb-1 mr-5 flex font-bold pb:text-white mt-8">Insira o código</label>
              <Input
                placeholder="*********"
                v-model="form.code"
                type="text"
                required
                autofocus
              />
            </li>
            <div v-if="$page.props.flash.error" class="mt-0 text-xs text-error">
                {{ $page.props.flash.error }}
            </div>
            <div v-if="$page.props.flash.success">
                {{ $page.props.flash.success }}
            </div>
            <li>
              <Button
                :enabled="allIsValid"
              >
                Verificar Código
              </Button>
            </li>
          </ul>
        </form>
        <Button
            @click.prevent="resendCode"
            >
            Reenviar o Código
        </Button>
    </div>
    </GuestLayout>

    <transition>
      <div v-if="showModal" class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-70 flex justify-center items-center">
        <div class="bg-white border-[1px] border-primary rounded-[4px] mx-2.5 w-2.5/12 px-4 py-4 leading-9">
          <button class="float-right" @click="showModal = false">
            <Icon name="Fechar"/>
          </button>
          <h1 class="text-[20px] font-bold text-primary">Código Enviado</h1>
          <p class="text-[16px] leading-6">O código de verificação foi enviado para <br /> o seu email.</p>
        </div>
      </div>
    </transition>

</template>
<script>
import Button from "@/Components/Button.vue";
import Input from "@/Components/UI/Form/Input.vue";
import Icon from '@/Components/UI/Icons/Icon.vue'
import GuestLayout from "@/Layouts/Guest.vue";
import Header from '@/Components/UI/Nav/Header.vue'
import { Head, Link} from "@inertiajs/inertia-vue3";

export default {
    components: {
        Button,
        Header,
        Head,
        Input,
        Icon,
        Link,
        GuestLayout,
    },
    props: {
      codeSended: Boolean,
      status: String,
      email: String,
      sended: String,
    },
    computed: {
        allIsValid: function() {
            return this.form.code ? true : false
        }
    },
    data() {
        return {
          recoveryEmail: this.email || sessionStorage.getItem('recoveryEmail'),
          showModal: !!!(this.sended),
          form: this.$inertia.form({
              code: "",
              email: this.email || sessionStorage.getItem('recoveryEmail'),
          })
        }
    },
    methods: {
      submit() {

        if(this.form) {
          sessionStorage.setItem('code', this.form.code)
          sessionStorage.setItem('recoveryEmail', this.form.email)
          this.$inertia.post('/forgot-password-verification', this.form);
        }
      },
      resendCode() {
          this.$inertia.post('/forgot-password/resend', {
              email: this.recoveryEmail
          });
      }
    }
}
</script>
